/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import { ucwords } from '../../../../../applications/helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function CreateRangeModal({
  newBusinessesId,
  createNewBusinessActivities,
  formData,
  setFormData,
  getSingleNewBusinesses,

  getNewBusinessNatureIdList,
  newBusinessNatureIdList,

  getNewBusinessLineIdList,
  newBusinessLineIdList,

  getNecessaryFieldsList,
  necessaryFieldsList,
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    business_nature_id: 'required',
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
  });

  useEffect(() => {
    getNewBusinessNatureIdList();
    setFormData({
      business_nature_id: '',
      business_line_id: '',
      capital_amount: '',
      gross_amount: '',
    });
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const necessarydetails = _.omit(
      formData,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount'
    );

    const args = {
      business_nature_id: _.get(formData, 'business_nature_id'),
      business_line_id: _.get(formData, 'business_line_id'),
      capital_amount: _.get(formData, 'capital_amount'),
      gross_amount: _.get(formData, 'gross_amount'),
      details: { ...necessarydetails },
    };

    createNewBusinessActivities(newBusinessesId, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(newBusinessesId);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNewBusinessLineIdList({ business_nature_id: e.value });
  };

  const selectBusinessNatureId = newBusinessNatureIdList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNecessaryFieldsList({ business_line_id: e.value });
  };

  const selectBusinessLineId = newBusinessLineIdList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleOfficeTypeDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = key => e => {
    if (key === 'capital_amount' || key === 'gross_amount') {
      setFormData({
        ...formData,
        [key]: e.target.value,
      });
      return false;
    }

    setFormData({
      ...formData,
      [key]: e.target.value,
    });

    return false;
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Business Nature:{' '}
              {validateForm.renderMessage('business_nature_id')}
            </label>
            <Select
              options={selectBusinessNatureId}
              placeholder="Select Business Nature"
              onChange={handleNatureDropDownChange('business_nature_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Business Line: {validateForm.renderMessage('business_line_id')}
            </label>
            <Select
              options={selectBusinessLineId}
              placeholder="Select Business Line"
              onChange={handleLineDropDownChange('business_line_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Capital Amount: {validateForm.renderMessage('capital_amount')}
            </label>
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  capital_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'capital_amount', '')}` || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Gross Amount: {validateForm.renderMessage('gross_amount')}
            </label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  gross_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'gross_amount', '')}` || ''}
            />
          </div>
          <div className="col-12 form-group">
            {necessaryFieldsList.map(item => {
              return (
                <div>
                  <div>
                    {_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}
                        </label>
                        <Select
                          onChange={handleOfficeTypeDropDownChange(
                            _.get(item, 'multiplier')
                          )}
                          options={selectOptions(_.get(item, 'options'))}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="form-group">
                    {!_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}
                        </label>
                        <input
                          className="form-control"
                          name={_.get(item, 'label')}
                          id={_.get(item, 'label')}
                          onChange={handleOnChange(_.get(item, 'multiplier'))}
                          value={_.get(formData, _.get(item, 'multiplier'))}
                          required
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   ">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateRangeModal.propTypes = {
  newBusinessesId: PropTypes.string.isRequired,
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  createNewBusinessActivities: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,

  getNewBusinessNatureIdList: PropTypes.instanceOf(Function).isRequired,
  newBusinessNatureIdList: PropTypes.instanceOf(Array).isRequired,

  getNewBusinessLineIdList: PropTypes.instanceOf(Function).isRequired,
  newBusinessLineIdList: PropTypes.instanceOf(Array).isRequired,

  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessNatureIdList:
    _.get(api, `${c.GET_NEW_BUSINESS_NATURE_ID}.list`) || [],
  newBusinessLineIdList: _.get(api, `${c.GET_NEW_BUSINESS_LINE_ID}.list`) || [],
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateRangeModal);
